import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FacultyService } from '../../services/faculty.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../services/loader.service';
@Component({
  selector: 'push-event-modal',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './push-event-modal.component.html',
  styleUrl: './push-event-modal.component.css'
})
export class PushEventModalComponent implements OnInit {
  @Input() batch: any;

  eventName = '';
  selectedCompany: any;
  selectedProduct: any;
  selectedFeatures: any;
  selectedSegment: any;
  value = '';
  subRound = '';
  deleteIndex: number | null = null;
  eventType: any;


  eventList: any[] = [];

  eventTypes: any[] = [];

  companies: any[] = [];

  products: any[] = [];

  segments: any[] = [];

  features: any[] = [];

  constructor(public activeModal: NgbActiveModal, private ngbModal: NgbModal, private facultyService: FacultyService, private toast: ToastrService,private loader: LoaderService) { }

  onEventTypeChange() {
    const type = this.eventTypes.find((event: any) => event.EventName === this.eventName);
    console.log(type);

    this.eventType = type.EventType;
    this.selectedCompany = null;
    this.selectedProduct = null;
    this.selectedFeatures = null;
    this.selectedSegment = null;
  }

  ngOnInit() {
    this.getEventList();
    this.getPreSelectData()
    this.getCompanyList(this.batch.SDBatchId, this.batch.RoundsPlayed);
    this.getSegmentList(this.batch.SDBatchId, this.batch.RoundsPlayed);
    this.getFeatureList(this.batch.SDBatchId, this.batch.RoundsPlayed);

  }

  addEvent() {
    if (!this.eventName) {
      this.toast.error('Please select Event Type', 'Error');
      return;
    }

    if (!this.value || !this.subRound) {
      this.toast.error('Please enter value and subround', 'Error');
      return;
    }

    // if (!this.value || this.value.length < 25) {
    //   alert('Value must be at least 25 characters');
    //   return;
    // }

    let companyID: any = null;
    let productID: any = null;
    let eventId: any = null;
    let eventType: any = null;

    if (this.selectedCompany) {
      const company = this.companies.find(
        (c: any) => c.CompanyName === this.selectedCompany
      );
      companyID = company ? company.CompanyId : null;
    }

    if (this.selectedProduct) {
      const product = this.products.find(
        (p: any) => p.ProductName === this.selectedProduct
      );
      productID = product ? product.ProductId : null;
    }

    if(this.eventName){
      const event = this.eventTypes.find(
        (e: any) => e.EventName === this.eventName
      );
      eventId = event ? event.EventId : null;
      eventType = event ? event.EventType : null;
    }

    this.eventList.push({
      EventName: this.eventName,
      EventType: eventType? eventType : '',
      EventId: eventId? eventId : '',
      EventCompany: companyID? companyID : '',
      EventCompanyName: this.selectedCompany? this.selectedCompany : '',
      EventProduct: productID? productID : '',
      EventProductName: this.selectedProduct? this.selectedProduct : '',
      EventFeature: this.selectedFeatures? this.selectedFeatures : '',
      EventSegment: this.selectedSegment? this.selectedSegment : '',
      EventVal: this.value? this.value : '',
      EventSR: this.subRound? this.subRound : '',
    });


    this.resetForm();
  }


  removeEvent(index: number) {
    this.eventList.splice(index, 1);
  }

  submitAll() {
    console.log(this.eventList);
    this.loader.showLoader();
    const param = {
      SDBatchId: this.batch.SDBatchId,
      RoundNo: this.batch.RoundsPlayed,
      EventSelected: this.eventList
    };

    this.facultyService.submitEvent(param).subscribe((resp) => {
      if (resp.errorCode === '000000') {
        this.activeModal.close(this.eventList);
        this.eventList = [];
        this.toast.success('Data submitted successfully', 'Success');
        this.loader.hideLoader();
      } else {
        this.toast.error(resp.errorDescription, 'Error');
        this.loader.hideLoader();
      }

    });
  }

  resetForm() {
    this.eventName = '';
    this.selectedCompany = null;
    this.selectedProduct = null;
    this.selectedFeatures = null;
    this.selectedSegment = null;
    this.value = '';
    this.subRound = '';
  }

  openConfirmationModal(confirmationModal: any, index: number) {
    this.deleteIndex = index;

    const modalRef = this.ngbModal.open(confirmationModal, {
      windowClass: 'confirmation-modal',
      backdrop: 'static',
      backdropClass: 'confirmation-modal-backdrop'
    });

    modalRef.result.then(
      (result) => {
        if (result === 'Yes' && this.deleteIndex !== null) {
          this.removeEvent(this.deleteIndex);
          this.deleteIndex = null;
        }
      },
      () => {
        this.deleteIndex = null;
      }
    );
  }




  getCompanyList(batchId: number, roundId: number) {
    this.facultyService.getCompanyList(batchId, roundId).subscribe((resp) => {
      this.companies = resp.Data;
    });
  }

  getProductList(vairantId: number, CompanyID: number) {
    const findCompanyId = this.companies.find((company: any) => company.CompanyName === CompanyID);
    this.facultyService.getProductList(vairantId, findCompanyId.CompanyId).subscribe((resp) => {
      this.products = resp.Data;
    });
  }

  getFeatureList(batchId: number, roundId: number) {
    this.facultyService.getFeatureList(batchId, roundId).subscribe((resp) => {
      this.features = resp.Data;
    });
  }

  getSegmentList(batchId: number, roundId: number) {
    this.facultyService.getSegmentList(batchId, roundId).subscribe((resp) => {
      this.segments = resp.Data.SegmentNames;
    });
  }

  onCompanyChange() {
    this.getProductList(this.batch.VariantId, this.selectedCompany);
  }

  getPreSelectData() {
    this.facultyService.getSEventData(this.batch.SDBatchId, this.batch.RoundsPlayed).subscribe((resp) => {
      if (resp.Data.length > 0) {
        this.eventList = resp.Data;
      }
    });
  }

  getEventList() {
    this.facultyService.getAllEventList(this.batch.VariantId).subscribe((resp) => {
      this.eventTypes = resp.Data;
    });
  }

}
